<template>
  <div :class="'location-product-detail-thccbd' + (product.category && product.category.thc_cbd_value_type ? ' type-' + product.category.thc_cbd_value_type : '')">
    <p v-if="product.cannabis_attributes && product.cannabis_attributes.plant_type" class="is-size-16 has-text-weight-semibold letter-space-1 is-capitalized">{{ product.cannabis_attributes.plant_type }}</p>
      <div :class="'loc-prod-detail-thccbd-wrap'">
        <p class="is-size-14 has-text-weight-semibold">THC</p>
        <p class="is-size-30px">{{ thc }}</p>
        <div :class="'weed-thc-indicator ' + (product.thc_cbd_levels ? product.thc_cbd_levels.thc_level : '')"><span></span><span></span><span></span></div>
      </div>
      <div class="loc-prod-detail-thccbd-wrap">
        <p class="is-size-14 has-text-weight-semibold">CBD</p>
        <p class="is-size-30px">{{ cbd }}</p>
        <div :class="'weed-cbd-indicator ' + (product.thc_cbd_levels ? product.thc_cbd_levels.cbd_level : '')"><span></span><span></span><span></span></div>
      </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';

export default {
  name: 'LocationProductDetailThcCbd',
  data() {
    return {
    };
  },
  
  props:{
    product: {
      required: true,
      type: Object,
    },
  },

  computed: {
    thc() {
      return Helpers.getTHCValue(this.product);
    },
    cbd() {
      return Helpers.getCBDValue(this.product);
    },
    ...mapGetters({
      vg_selectedLocation: "location/selected",
      vg_favProducts: "favouriteproducts/list",
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_userId: "getLoggedInUserId",
    }),
  },

  mounted() {

  },
  
  methods: {

  },
};
</script>


